<template>
  <v-container grid-list-lg fluid pt-0 pb-4>
    <vue-perfect-scrollbar>
      <v-flex xs12 class="config-table-container">
        <data-table
          :filters="filters"
          :limit="10"
          url="users"
          :fields="fields"
          content="ChatCenterUserList"
          searchFields="first_name,last_name,email"
          class="mb-5">
          <template slot="navigation-bar">
            <v-flex md12>
              <v-text-field
                v-model="filters.search"
                label="Buscar..."
                color="black"
                solo>
              </v-text-field>
            </v-flex>
          </template>
        </data-table>
      </v-flex>
    </vue-perfect-scrollbar>
  </v-container>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import DataTable from '@/components/global/DataTable';
import ChatCenterUserList from './ChatCenterUserList';

Vue.component('ChatCenterUserList', ChatCenterUserList);

export default {
  components: {
    DataTable,
    VuePerfectScrollbar,
  },
  computed: {
    channelRoute() {
      return `chats_centers/${this.user.id}/config`;
    },
    channelsTitle() {
      return `Canales asignados al usuario ${this.user.name}`;
    },
  },
  data() {
    return {
      filters: {
        search: '',
        sort: '-created_at',
      },
      form: {
        close: 0,
        close_category_id: null,
        agent_limit: 0,
        away_time: 0,
        name: '',
      },
      roles: [
        {
          value: 1,
          text: 'Administrador',
        },
        {
          value: 2,
          text: 'Analista',
        },
        {
          value: 3,
          text: 'Agente',
        },
        {
          value: 4,
          text: 'Call center',
        },
      ],
      fields: 'email, first_name, last_name, last_activity, role.display_name, chat_center_filters, status, created_at',
      showChatCenterConfig: false,
    };
  },
  methods: {
    showConfig() {
      this.axios.get('chats_centers/config').then(({ data }) => {
        if (data) {
          const temp = _.pick(data, ['close', 'close_category_id', 'agent_limit', 'away_time', 'chat_category.name']);
          temp.name = (temp.chat_category || {}).name;
          delete temp.chat_category;
          this.form = temp;
        }
        this.showChatCenterConfig = true;
      }).catch();
    },
    showSnack() {
      this.$emit('update:model', true);
      this.$emit('update:msg', 'Configuración guardada satisfactoriamente.');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/ChatCenterChannels.vue